import { render, staticRenderFns } from "./AndroidYandex.vue?vue&type=template&id=f1b31e62&scoped=true&"
import script from "./AndroidYandex.vue?vue&type=script&lang=js&"
export * from "./AndroidYandex.vue?vue&type=script&lang=js&"
import style0 from "./AndroidYandex.vue?vue&type=style&index=0&id=f1b31e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b31e62",
  null
  
)

export default component.exports